import {Modal} from "../components/Modal/Modal";
import React from "react";
import {DefaultButtonMenu} from "./DefaultButtonMenu";
import {Leaderbord} from "./Leaderbord/Leaderbord";
import {useAppContext} from "../provider/AppProvider";

interface Props {
    isOpen: boolean;
    restart?: () => void;
    onShowHint?: (p: boolean) => void;
}

export const SettingsModal = ({isOpen, restart, onShowHint}: Props) => {
    const {showLeaderBoard, onSwitchLeaderBord, onSwitchSettings} = useAppContext();

    return (
        <>
            {showLeaderBoard && <Leaderbord isOpen={showLeaderBoard} />}
            <Modal type='blue' isOpen={isOpen && !showLeaderBoard} onClose={onSwitchSettings}>
                <DefaultButtonMenu onShowHint={onShowHint} setShowLeaderBord={onSwitchLeaderBord} restart={restart} />
            </Modal>
        </>
    )
}
